import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Mail } from "lucide-react";
import api from "@/lib/api";

export default function LeadCaptureForm() {
  const [form, setForm] = useState({ name: "", email: "", occasion: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) return toast.error("Name and email please!");
    setLoading(true);
    try {
      await api.post("/leads/capture", { ...form, source: "home_widget" });
      setDone(true);
    } catch {
      toast.error("Something went wrong — try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="brut-card p-8 bg-grape/20" data-testid="lead-capture">
      <span className="tag-pill bg-sun mb-4"><Sparkles className="w-4 h-4" /> Join the list</span>
      {done ? (
        <div data-testid="lead-capture-success">
          <h3 className="font-display font-bold text-2xl sm:text-3xl">You're in! 🎉</h3>
          <p className="text-ink/70 mt-2 text-lg">Check your inbox — a little welcome is on its way. We'll send fun updates, examples, and the occasional special offer.</p>
        </div>
      ) : (
        <>
          <h3 className="font-display font-bold text-2xl sm:text-3xl">Get updates &amp; special offers</h3>
          <p className="text-ink/70 mt-1 mb-5">Drop your details and we'll send new examples, tips for the perfect gift, and members-only deals.</p>
          <form onSubmit={submit} className="grid sm:grid-cols-2 gap-3">
            <input data-testid="lead-name" className="brut-input" placeholder="Your name"
              value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input data-testid="lead-email" type="email" className="brut-input" placeholder="you@email.com"
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input data-testid="lead-occasion" className="brut-input sm:col-span-2" placeholder="What's the occasion? (optional)"
              value={form.occasion} onChange={(e) => setForm({ ...form, occasion: e.target.value })} />
            <button type="submit" disabled={loading} data-testid="lead-submit"
              className="brut-btn bg-bubble text-white sm:col-span-2 text-lg justify-center">
              <Mail className="w-5 h-5" /> {loading ? "Joining…" : "Count me in"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
